<template>
    <div class="modal comments-modal">
        <div
            class="modal__background"
            @click="close"
        />
        <div class="modal__foreground comments-modal__foreground">
            <div class="modal__header">
                <h2 class="comments-modal__title">
                    {{ modal_title }}
                </h2>
                <button
                    class="modal__close"
                    @click.prevent="close"
                >
                    <i class="fa fa-times" />
                </button>
            </div>

            <div class="modal__body comments-modal__body">
                <comments />
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import Comments from "./CommentsComponent";

export default {
    components: {
        Comments
    },

    data() {
        return {
            comment_text: ""
        };
    },

    computed: {
        ...mapState("comments", ['modal_title'])
    },

    watch: {
        comments() {
            this.scrollToBottom();
        }
    },

    methods: {
        ...mapMutations("comments", ["hideModal"]),

        close() {
            this.$emit("close");
            this.hideModal();
        },
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/CommentsModalComponent.vue